<nb-card>
    <nb-card-header class="title-dialog">
      <h3 h3 style="color: white;">Opciones del Reporte</h3>  
    </nb-card-header>
    <nb-card-body style="text-align: left;">
       <ng-container *ngIf="usarCheckbox == true; else mostrarToggles">

        <nb-toggle [checked]="grillaAverias" (checkedChange)="grillaAverias = $event">Grilla de averías</nb-toggle> <br>
        <nb-toggle [checked]="grillaModelo" (checkedChange)="grillaModelo = $event">Grilla de resumen por modelo</nb-toggle> <br>
        <nb-toggle [checked]="grillaClasificacion" (checkedChange)="grillaClasificacion = $event">Grilla de resumen por clasificación</nb-toggle> <br>
        <nb-toggle [checked]="indicadores" (checkedChange)="indicadores = $event">Indicadores</nb-toggle> <br>
        <nb-toggle [checked]="detalleAverias"  (checkedChange)="detalleAverias = $event; fotosAverias = $event ? false : fotosAverias">Detalle de averías</nb-toggle> <br>
        <nb-toggle [checked]="fotosAverias" (checkedChange)="fotosAverias = $event; detalleAverias = $event ? true : detalleAverias">Fotos de averías</nb-toggle> <br>
   
      </ng-container>

     <ng-template #mostrarToggles>
        <nb-toggle [checked]="grillaAverias" (checkedChange)="grillaAverias = $event">Grilla de averías</nb-toggle> <br>
        <nb-toggle [checked]="grillaModelo" (checkedChange)="grillaModelo = $event">Grilla de resumen por modelo</nb-toggle> <br>
        <nb-toggle [checked]="grillaClasificacion" (checkedChange)="grillaClasificacion = $event">Grilla de resumen por clasificación</nb-toggle> <br>
        <nb-toggle [checked]="indicadores" (checkedChange)="indicadores = $event">Indicadores</nb-toggle> <br>
        <nb-toggle [checked]="detalleAverias"  (checkedChange)="detalleAverias = $event; fotosAverias = $event ? false : fotosAverias">Detalle de averías</nb-toggle> <br>
        <nb-toggle [checked]="fotosAverias" (checkedChange)="fotosAverias = $event; detalleAverias = $event ? true : detalleAverias">Fotos de averías</nb-toggle> <br>
  
      </ng-template> 

    </nb-card-body>

    
    <nb-card-footer>
        <app-spinner *ngIf="showSpinner" class="col-2 float-left margin-right"></app-spinner>
        <button *ngIf="!showSpinner" nbButton size="tiny"  class="buttontz col-2 float-left margin-right" (click)="invocarReportes()">Generar Reporte</button>
        <button *ngIf="!showSpinner" nbButton size="tiny"  class="buttontz col-2 float-right margin-right" (click)="cerrarModal()" >Cancelar</button>
    </nb-card-footer>
</nb-card>